import { gql } from '@apollo/client';

export const GET_MOVEMENT_MONEY_DATA = gql`
  query getMovementMoney($id: Int) {
    getWorkShiftPaymentOverviewData(id: $id) {
      deposit
      online_deposit
    }
  }
`;
